import React, { Fragment, useEffect, useState, useRef } from "react";
import { ToastContainer, toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import {
  getCollegeFees,
  updateCollegeFeePaymentDetails,
  getStudentProfileByFormNumber,
  getStudentProfileForUpdateOnly
} from "../../api/admissionApi";
import moment from "moment";
import LoaderSpinner from "../../common/LoaderSpinner";
import Popup from "../../Shared/Popup";
import FileUpload from "../../common/FileUpload";
import { uploadSingleFileToS3 } from "../../api/fileUploadApi";



function CollegeFeePayment(props = {}) {
  const {
    isEdit = false,
    isCreate = false,
    verifyAndSearchUser,
    verificationSuccess,
    searchingUser,
    userInformation = {},
    currentUser,
    setActiveTab,
    // existingDA,
    existingSalaryConfig = {},
    editorId = "",
    history,
    isUpdating,
    permissions = {},
    activeTab
  } = props;
  const dispatch = useDispatch();
  const state = useSelector((state) => state);
  const {
    authenticationReducer: {
      studentProfile: { is_registration_completed, email_id, formNumber, collegeFeePayment_status },
      isStudent,
    } = {},
    admissionReducer: { isUserProfileLoading = false } = {},
  } = state || {};
  // const { collegeFeeDemandDraftFront, collegeFeeDemandDraftBack } = collegeFeePayment_status;

  const form_number = formNumber;
  const fileUploadRef = useRef(null);
  const [isFetchingCollegeFees, setIsFetchingCollegeFees] = useState(false);
  const [isCollegeFeesPaid, setIsCollegeFeesPaid] = useState(false);
  const [collegeFees, setCollegeFees] = useState(0);
  const getCollegeFee = (cbs) => dispatch(getCollegeFees(cbs));
  const [openEventPopup, setopenEventPopup] = useState(false);
  const [customPopupTitle, setcustomPopupTitle] = useState("");
  const [customPopupContent, setcustomPopupContent] = useState();
  const [collegeFeeDemandDraftFileFront, setCollegeFeeDemandDraftFileFront] = useState("");
  const [collegeFeeDemandDraftFileBack, setCollegeFeeDemandDraftFileBack] = useState("");
  const [showTooltipONLINE, setShowTooltipONLINE] = useState(false);
  const [showTooltipDD, setShowTooltipDD] = useState(false);
  const getStudProfileForUpdateOnly = (email, cbs) => dispatch(getStudentProfileForUpdateOnly(email, cbs));

  const completePayment = (data, cbs) =>
    dispatch(updateCollegeFeePaymentDetails(data, cbs));
  const getStudProfileByFormNo = (formNumber, cbs) =>
    dispatch(getStudentProfileByFormNumber(formNumber, cbs));
  const [paymentStatuses, setPaymentStatuses] = useState({
    isCollegeFeePaid: "",
    collegeFeePaidTransactionId: "",
    collegeFeesPaidDate: "",
  });
  const [collegeFeeDDPaymentDetails, setCollegeFeeDDPaymentDetails] = useState({
    collegeFeeDemandDraftFront: "",
    collegeFeeDemandDraftBack: "",
    update_date: ""
  });

  useEffect(() => {
    setIsFetchingCollegeFees(true);
    getCollegeFee({
      successCallback: collegeFeeFetchSuccessCallback,
      failureCallback: collegeFeeFetchFailureCallback,
    });
  }, []);
  useEffect(() => {
    if (formNumber) {
      const callbacks = {
        successCallback: getStudentProfileSuccessCallback,
        failureCallback: getStudentProfileFailureCallback,
      };
      if (!isStudent && formNumber)
        getStudProfileByFormNo(formNumber, callbacks);
      else toast.error("Permission denied!!");
    }
  }, [formNumber]);
  const getStudentProfileSuccessCallback = (data = {}) => {
    // console.log("getStudentProfileSuccessCallback: ",data);
    const { profileDetails: { payment_status, collegeFeeDDPayment_status } = {} } = data;
    setPaymentStatuses({
      ...paymentStatuses,
      isCollegeFeePaid: payment_status?.isCollegeFeePaid,
      collegeFeePaidTransactionId: payment_status?.collegeFeePaidTransactionId,
      collegeFeesPaidDate: payment_status?.collegeFeesPaidDate,
    });
    if(collegeFeeDDPayment_status && Object.keys(collegeFeeDDPayment_status).length > 0) {
      setCollegeFeeDDPaymentDetails({
      ...collegeFeeDDPaymentDetails,
      collegeFeeDemandDraftFront: collegeFeeDDPayment_status.collegeFeeDemandDraftFront,
      collegeFeeDemandDraftBack: collegeFeeDDPayment_status.collegeFeeDemandDraftBack,
      update_date: collegeFeeDDPayment_status.update_date
    });
    setCollegeFeeDemandDraftFileFront(collegeFeeDDPayment_status.collegeFeeDemandDraftFront);
    setCollegeFeeDemandDraftFileBack(collegeFeeDDPayment_status.collegeFeeDemandDraftBack);
    }
  };

  const getStudentProfileFailureCallback = (errData) => {
    console.log("errData", errData);
    toast.error("Couldn't load your profile.");
    // setIsStudentProfileFetched(false);
    // if(errData.data.registrations === "No registrations found with provided filters")  toast.error(errData.data.registrations);
    // if (errData !== undefined && errData.data) toast.error(errData.data.err);
    // MOMENT WHEN WRONG INPUT IS PASSED OR SOME OTHER TECHNICAL ERROR OCCURED
    // else alert("Error with your network, please try again!");
  };

  const collegeFeeFetchSuccessCallback = (response) => {
    setIsFetchingCollegeFees(false);
    setCollegeFees(response.collegeFees);
  };
  const collegeFeeFetchFailureCallback = (errData) => {
    setIsFetchingCollegeFees(false);
    toast.error("Couldn't find college fees, please refresh the page!");
    collegeFees(0);
  };

  const completePaymentHandler = (event) => {
    event.preventDefault();
    event.stopPropagation();
    //call api to update only payment status
    if (collegeFees) {
      const requestPayload = {
        paymentMode: "online",
        formNumber: form_number,
        collegeFeePaidTransactionId: "123456789",
      };
      const callbacks = {
        successCallback: completePaymentSuccessCallback,
        failureCallback: completePaymentFailureCallback,
      };
      completePayment(requestPayload, callbacks);
    } else {
      toast.failure("Form number not available, please refresh.");
    }
  };
  const completePaymentSuccessCallback = (response) => {
    // console.log("completePaymentSuccessCallback: ", response);
    setIsCollegeFeesPaid(true);
    toast.success(response.message);
    setopenEventPopup(false);
    setTimeout(() => window.location.reload(), 2500);
  };
  const completePaymentFailureCallback = (errData) => {
    // console.log("completePaymentFailureCallback: ", errData.data);
    setIsCollegeFeesPaid(false);
    toast.error(
      "Error paying college fees, retry again! No amount is deducted."
    );
  };

  const updateDDPaymentdetails = (event) => {
    event.preventDefault();
    event.stopPropagation();
    if(collegeFeeDemandDraftFileFront !== "" && collegeFeeDemandDraftFileBack !== "") {
      const requestPayload = {
        paymentMode: "DD",
        formNumber: form_number,
        front: collegeFeeDemandDraftFileFront,
        back: collegeFeeDemandDraftFileBack
      };
      const callbacks = {
        successCallback: updateDDPaymentdetailsSuccessCallback,
        failureCallback: updateDDPaymentdetailsFailureCallback,
      };
      completePayment(requestPayload, callbacks);
    } else {
      toast.failure("Pleae upload complete DD photos before submitting.");
      }
  };
  const updateDDPaymentdetailsSuccessCallback = (response) => {
    console.log("completePaymentSuccessCallback: ", response);
    toast.success(response.message);
    setTimeout(() => window.location.reload(), 2500);
  };
  const updateDDPaymentdetailsFailureCallback = (errData) => {
    console.log("completePaymentFailureCallback: ", errData.data);
    toast.error(
      "Error updating DD details, retry again!"
    );
  };

  const cancelPaymentHandler = (event) => {
    //reset any payment state saved
    setopenEventPopup(false);
  };

  const payCollegeFeesHandler = (event) => {
    if (collegeFees) {
      setcustomPopupTitle(`Amount to be paid: ${collegeFees}`);
      setcustomPopupContent(
        <div className="popup-content" style={{ textAlign: "center" }}>
          <div className="pb-20">
            Choose mode of payment:
            <div
              className="pt-20"
              style={{ display: "flex", justifyContent: "space-around" }}
            >
              <div>
                <input type="radio" value="credit_card" name="payment_mode" />
                Credit card
              </div>
              <div>
                <input type="radio" value="debit_card" name="payment_mode" />
                Debit card
              </div>
              <div>
                <input type="radio" value="upi" name="payment_mode" />
                UPI
              </div>
            </div>
          </div>
          <button
            type="submit"
            className="mr-3 btn btn-primary"
            onClick={(e) => completePaymentHandler(e)}
          >
            Complete payment
          </button>
          <button
            type="submit"
            className="mr-3 btn btn-primary"
            onClick={(e) => cancelPaymentHandler(e)}
          >
            Cancel payment
          </button>
        </div>
      );
      setopenEventPopup(true);
    }
  };

  const updateFileUploadStatus = (newFiles, fieldName, uploadStatusObj) => {
    uploadStatusObj.uploading();
    if (newFiles) {
      const callbacks = {
        successCallback: fileUploadSuccessCallback,
        failureCallback: fileUploadFailureCallback,
      };
      dispatch(
        uploadSingleFileToS3(newFiles, fieldName, callbacks, uploadStatusObj)
      );
    }
  };

  const fileUploadSuccessCallback = (resp, fieldName, uploadStatusObj) => {
    const { link = "", fileCategory = "" } = resp;
    // setUserPaymentInfo({...userPaymentInfo, payment_doc_url: link});
    if(fieldName === "collegeFeeDemandDraftFront") setCollegeFeeDemandDraftFileFront(link);
    else setCollegeFeeDemandDraftFileBack(link);
    uploadStatusObj.uploadSuccess();
  };
  const fileUploadFailureCallback = (resp, uploadStatusObj) => {
    uploadStatusObj.uploadFailure();
  };

  const renderHeader = () => {
    return (
      <Fragment>
        <div className="section-body">
          <div className="container-fluid">
            <div className="d-flex justify-content-between align-items-center ">
              <div className="header-action">
                <h1 className="page-title">College entrance fee payment</h1>
                <ol className="breadcrumb page-breadcrumb">
                  <li className="breadcrumb-item">
                    <a href>St. Andrews College</a>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Entrance fee payment
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  };

  const renderContent = () => {
    return (
      <div className="card">
        <div className="card-header">
          <h3 className="card-title">
            Pay your entrance fees to get eligible for examination
          </h3>
        </div>
        {formNumber ? (<div className="pl-20">
          {formNumber && (
            <p className="mb-0">
              Congratulations! You've successfully completed your registration,
              your form number is: {formNumber}
            </p>
          )}
          {!paymentStatuses.isCollegeFeePaid && (<p className="mb-0">
            For your next step towards admission, you need to submit the college
            fees of amount : &nbsp;&#8377;{collegeFees}
          </p>)}
          {isFetchingCollegeFees ? (
            <span>
              Loading...
              <LoaderSpinner />
            </span>
          ) : (
            (collegeFees !== 0 && !paymentStatuses.isCollegeFeePaid) ? (
              <Fragment>
                <div className="pl-15 pt-10 pb-10">
                <strong>Pay Online:</strong> &nbsp;<button
                  value="download"
                  type="button"
                  className="btn btn-primary ml-100"
                  disabled={isFetchingCollegeFees || !collegeFees || (collegeFeeDDPaymentDetails.update_date && !paymentStatuses.isCollegeFeePaid)}
                  onClick={(e) => payCollegeFeesHandler(e)}
                >
                  Pay &nbsp;&#8377;{collegeFees}
                </button>
                
              </div>
              <div className="d-flex align-items-center">
                <i
                  className="fa fa-exclamation-circle ml-20 mb-20"
                  aria-hidden="true"
                  style={{
                    color: "orange",
                    fontSize: "1.2em",
                    cursor: "pointer",
                  }}
                  onMouseEnter={() => setShowTooltipONLINE(true)}
                  onMouseLeave={() => setShowTooltipONLINE(false)}
                ></i>
                {showTooltipONLINE && (
                  <div className="ml-3 text-danger">
                   Please note: In this mode, verification will be done automatically and Entrance roll number will be generated.
                  </div>
                )}
              </div>
              ---OR---
              <div className="pl-20 pt-10 pb-10" style={{display: "flex"}}>
                <strong>Pay via Demand Draft:</strong> &nbsp;
                <div className="ml-25">
                  <p className="text-primary mb-1">Upload front side:</p>
                  <FileUpload
                    isDisabled={Boolean(collegeFeeDDPaymentDetails.update_date && !paymentStatuses.isCollegeFeePaid)}
                    fileUploadRef={fileUploadRef}
                    fieldName="collegeFeeDemandDraftFront"
                    setSelectedFiles={setCollegeFeeDemandDraftFileFront}
                    selectedFiles={collegeFeeDemandDraftFileFront}
                    fileUploadStatus={updateFileUploadStatus}
                    uploadedFileUrl={collegeFeeDemandDraftFileFront}
                  />
                </div>
                <div className="ml-25">
                  <p className="text-primary mb-1">Upload back side:</p>
                  <FileUpload
                    isDisabled={Boolean(collegeFeeDDPaymentDetails.update_date && !paymentStatuses.isCollegeFeePaid)}
                    fileUploadRef={fileUploadRef}
                    fieldName="collegeFeeDemandDraftBack"
                    setSelectedFiles={setCollegeFeeDemandDraftFileBack}
                    selectedFiles={collegeFeeDemandDraftFileBack}
                    fileUploadStatus={updateFileUploadStatus}
                    uploadedFileUrl={collegeFeeDemandDraftFileBack}
                  />
                </div>
              </div>
              <div className="d-flex align-items-center">
                <i
                  className="fa fa-exclamation-circle ml-20 mb-20"
                  aria-hidden="true"
                  style={{
                    color: "orange",
                    fontSize: "1.2em",
                    cursor: "pointer",
                  }}
                  onMouseEnter={() => setShowTooltipDD(true)}
                  onMouseLeave={() => setShowTooltipDD(false)}
                ></i>
                {showTooltipDD && (
                  <div className="ml-3 text-danger">
                   Please note: In this mode you will have to manually get your DD verified from the college department.
                  </div>
                )}
              </div>
              {(collegeFeeDDPaymentDetails.update_date && !paymentStatuses.isCollegeFeePaid) ?
              <Fragment>
               <p className="mb-10 text-primary font-weight-bold"> You have already submitted your DD details on <span className="text-danger">{moment(collegeFeeDDPaymentDetails.update_date).format("DD-MMM-YY HH:MM")}</span>, kindly get your verification done from college department or wait if already visited the college.</p>
              </Fragment>                
              :<div className="pt-10 pb-10">
                <button
                  value="download"
                  type="button"
                  className="btn btn-primary"
                  disabled={ collegeFeeDemandDraftFileBack === "" || collegeFeeDemandDraftFileFront === "" || ( collegeFeeDDPaymentDetails.update_date && !paymentStatuses.isCollegeFeePaid )}
                  onClick={(e) => updateDDPaymentdetails(e)}
                >
                  Submit
                </button>
              </div>}
              
              </Fragment>
            ) : (
              <p className="mb-20">
                You've successfully paid college entrance fees, please wait for the examination results. Once updated it will be available <span style={{color: 'blue', cursor: "pointer"}} onClick={() => history.push('/feeCalculation')}>here</span>.
              </p>
            )
          )}
        </div>) : <p className="pl-20 text-danger ">You need to complete your registration first!</p>}
        {openEventPopup && (
          <Popup
            title={customPopupTitle}
            onCloseClick={() => setopenEventPopup(false)}
            content={customPopupContent}
          />
        )}
      </div>
    );
  };

  return (
    <Fragment>
      {renderHeader()}
      <div className="section-body mt-4">
        <div className="container-fluid">{renderContent()}</div>
      </div>
      <ToastContainer />
    </Fragment>
  );
}

export default CollegeFeePayment;
